<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  <el-breadcrumb-item>数据分析</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					
					
					
					<div class="neirong_line" style="margin-bottom: 0px; overflow: hidden;">
						<el-row>
							<el-col :span="12">
								<el-image :src="$common.adimgUrl + detail_ban[0].img" :title="detail_ban[0].title" style="cursor: pointer;" @click="toUrl(detail_ban[0].url)" fit="contain">
									<div slot="error" class="image-slot">
									</div>
								</el-image>
							</el-col>
							<el-col :span="12">
								<el-image :src="$common.adimgUrl + detail_ban[1].img" :title="detail_ban[1].title" style="cursor: pointer;" @click="toUrl(detail_ban[1].url)" fit="contain">
									<div slot="error" class="image-slot">
									</div>
								</el-image>
							</el-col>
						</el-row>
						
						<el-row>
							<el-col :span="12">
								<el-image :src="$common.adimgUrl + detail_ban[2].img" :title="detail_ban[2].title" style="cursor: pointer;" @click="toUrl(detail_ban[2].url)" fit="contain">
									<div slot="error" class="image-slot">
									</div>
								</el-image>
							</el-col>
							<el-col :span="12">
								<el-image :src="$common.adimgUrl + detail_ban[3].img" :title="detail_ban[3].title" style="cursor: pointer;" @click="toUrl(detail_ban[3].url)" fit="contain">
									<div slot="error" class="image-slot">
									</div>
								</el-image>
							</el-col>
						</el-row>
						
						
						
					</div>
					
					<!-- <div class="neirong_line" style="margin-bottom: 0px; overflow: hidden;">
						
					</div>
					
					<div class="neirong_line" style="margin-bottom: 0px; overflow: hidden;">
						
					</div>
					
					<div class="neirong_line" style="margin-bottom: 0px; overflow: hidden;">
						
					</div> -->
					
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
		},
		data() {
			return {
				
				detail_ban: [
					{title: '', url: '', img: ''},
					{title: '', url: '', img: ''},
					{title: '', url: '', img: ''},
					{title: '', url: '', img: ''}
				],
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			setTimeout(()=>{
				this.loadMenu('10092', 'shujufenxi') // 延迟加载上部图片
			}, 700)
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			
			// 加载菜单下配置数据
			loadMenu(config_id, return_obj) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					if (return_obj == 'shujufenxi') {
						this.detail_ban = list
						console.log(this.detail_ban)
					}
				})
			},
			
			
			
		}
	}
</script>

<style scoped>
.neirong_daohang_header_title {
	width: 120px;
}
</style>